import {
  ActionList,
  ActionListItem,
  Divider,
  GridItem,
  Link,
  PrimaryTag,
  Text,
} from "@certn/cascadia-react";
import React from "react";
import { Trans } from "react-i18next";

import { CredentialModal } from "./CredentialModal";
import { Credential } from "./type";

type CredentialsListProps = {
  credentials: Credential[];
  onSave: (credential: Credential) => void;
  onDelete: (index: number) => void;
  testID?: string;
  requireHighestLevel: boolean;
};

export function CredentialsList({
  credentials,
  onSave,
  onDelete,
  testID,
  requireHighestLevel,
}: CredentialsListProps) {
  const highestCredentialIndex = credentials.findIndex(
    ({ highest_level }) => highest_level
  );

  return (
    <GridItem>
      <ActionList testID={testID}>
        {credentials.map((credential) => (
          <React.Fragment key={credential.index}>
            <ActionListItem
              title={credential.certification ?? "-"}
              tag={
                credential.highest_level ? (
                  <PrimaryTag type="subtle">
                    <Trans>Highest level</Trans>
                  </PrimaryTag>
                ) : (
                  credential.current && (
                    <PrimaryTag type="subtle">
                      <Trans>In progress</Trans>
                    </PrimaryTag>
                  )
                )
              }
              trailing={
                <CredentialModal
                  index={credential.index}
                  credential={credential}
                  onSave={onSave}
                  onDelete={() => onDelete(credential.index)}
                  allowHighest={
                    requireHighestLevel &&
                    (highestCredentialIndex === -1 ||
                      highestCredentialIndex === credential.index)
                  }
                  trigger={
                    <Link
                      linkStyle="monochrome"
                      textStyle="global/body-secondary"
                      textColor="text-weak"
                      testID="credentials-edit-credential-button"
                    >
                      <Trans>Edit</Trans>
                    </Link>
                  }
                />
              }
            >
              <Text style="global/body-secondary" color="text-weak">
                {credential.institution}
              </Text>
            </ActionListItem>
            <Divider />
          </React.Fragment>
        ))}
      </ActionList>
    </GridItem>
  );
}
